import { ServiceNowLogInfo } from 'rcx_adapter';

interface LogPatchData {
    selectedName?: Pick<ServiceNowLogInfo, 'name'>;
    selectedRelatedTo?: Pick<ServiceNowLogInfo, 'relatedTo'>;
    subject?: string;
}

export function mapLogInfo(
    serviceNowInfo: Partial<ServiceNowLogInfo>
): LogPatchData {
    const keyArray: [keyof ServiceNowLogInfo, keyof LogPatchData][] = [
        ['relatedTo', 'selectedRelatedTo'],
        ['name', 'selectedName'],
        ['subject', 'subject'],
    ];
    return keyArray.reduce((pre, cur) => {
        const dataKey = cur[0];
        if (serviceNowInfo[dataKey]) {
            pre[cur[1]] = serviceNowInfo[dataKey];
        } else {
            pre[cur[1]] = { id: '' };
        }
        return pre;
    }, {} as any);
}

